__turbopack_context__.v({
  "arrow": "style-module-scss-module__xmS6mG__arrow",
  "arrow-movement": "style-module-scss-module__xmS6mG__arrow-movement",
  "arrowFirst": "style-module-scss-module__xmS6mG__arrowFirst",
  "arrowSecond": "style-module-scss-module__xmS6mG__arrowSecond",
  "isHidden": "style-module-scss-module__xmS6mG__isHidden",
  "isShow": "style-module-scss-module__xmS6mG__isShow",
  "wrapper": "style-module-scss-module__xmS6mG__wrapper",
});
